<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i">
<p class="half"><em class="italic">Napoleon</em> <span class="half3">in</span> <span class="half1">100</span> <span class="half2">OBJECTS</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?6c10d00e